var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StatCard',{attrs:{"title":_vm.cardTitle,"value":_vm.formattedValue,"icon":"attach_money","icon-class":"revenue-icon","trend":_vm.statsComparison.trend,"percentage":_vm.statsComparison.percentage,"comparison-period":_vm.comparisonPeriod}})
}
var staticRenderFns = []

export { render, staticRenderFns }